import { USER_DISABLED_ERROR } from "shared";

export const isUserDisabledError = (status: number, body: unknown) =>
  status === 401 &&
  typeof body === "object" &&
  body !== null &&
  "message" in body &&
  body.message === USER_DISABLED_ERROR;
